import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Michael R.',
      role: 'Small Business Owner',
      text: 'The team at Progress Insurance Solutions made the entire process simple and stress-free. They explained my options clearly and helped me find better coverage at a competitive price.',
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a'
    },
    {
      name: 'Jessica T.',
      role: 'Homeowner',
      text: 'I appreciate how responsive and knowledgeable their advisors are. They truly take the time to understand what you need.',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956'
    },
    {
      name: 'Daniel K.',
      role: 'Business Owner',
      text: 'Progress Insurance Solutions helped us secure the right commercial coverage for our company. Their guidance gave us confidence that we were fully protected.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d'
    },
    {
      name: 'Laura M.',
      role: 'Client',
      text: 'Professional, reliable, and very easy to work with. I highly recommend Progress Insurance Solutions for both personal and business coverage.',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80'
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">What Our Clients Say</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Don't just take our word for it. Hear from the clients we've had the privilege to serve.
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <Card key={index} className="border-2 hover:border-[#C9A361] transition-all hover:shadow-xl group">
                <CardContent className="p-8">
                  {/* Stars */}
                  <div className="flex gap-1 mb-6">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-[#C9A361] text-[#C9A361]" />
                    ))}
                  </div>
                  
                  {/* Testimonial Text */}
                  <p className="text-lg text-slate-700 mb-6 leading-relaxed italic">
                    "{testimonial.text}"
                  </p>
                  
                  {/* Author Info */}
                  <div className="flex items-center gap-4">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="w-14 h-14 rounded-full object-cover"
                    />
                    <div>
                      <div className="font-bold text-slate-900">{testimonial.name}</div>
                      <div className="text-sm text-slate-600">{testimonial.role}</div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-[#C9A361] mb-2">500+</div>
              <div className="text-xl text-slate-700">Satisfied Clients</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-[#C9A361] mb-2">15+</div>
              <div className="text-xl text-slate-700">Years of Experience</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-[#C9A361] mb-2">98%</div>
              <div className="text-xl text-slate-700">Client Satisfaction</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Request Your Personalized Insurance Quote</h2>
          <p className="text-xl text-slate-300 mb-8">
            Join hundreds of satisfied clients who trust Progress Insurance Solutions for their insurance needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-[#C9A361] hover:bg-[#B8925A] text-white px-8 py-6 text-lg transition-all hover:scale-105">
                Get Your Free Quote
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <a href="tel:954-495-2929">
              <Button size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-slate-900 px-8 py-6 text-lg transition-all">
                Call 954-495-2929
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
